import { useState, useEffect } from "react";
import axios from "axios";
import DOMPurify from "dompurify";
import { API } from "../App";

const DatenschutzPage = () => {
  const [content, setContent] = useState("");

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const res = await axios.get(`${API}/legal/datenschutz`);
        setContent(res.data.content);
      } catch (error) {
        console.error("Error fetching datenschutz:", error);
      }
    };
    fetchContent();
  }, []);

  return (
    <div data-testid="datenschutz-page">
      {/* Hero Section */}
      <section className="py-16" style={{ background: 'linear-gradient(135deg, #0A2A43 0%, #0A2A43 50%, #4a1a2a 85%, #6b1f2f 100%)' }}>
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-16 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white font-barlow italic">
            Datenschutzerklärung
          </h1>
        </div>
      </section>

      {/* Content */}
      <section className="section-padding bg-white">
        <div className="max-w-4xl mx-auto">
          <div 
            className="prose prose-lg max-w-none prose-headings:font-barlow prose-headings:text-[#0A2A43] prose-p:text-[#475569] prose-a:text-[#D32F2F]"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
            data-testid="datenschutz-content"
          />
        </div>
      </section>
    </div>
  );
};

export default DatenschutzPage;
